import { useTranslation } from "react-i18next";

interface StatusBadgeProps {
  status: boolean;
  className?: string;
}

const statusConfig = {
  active: {
    color: "bg-green",
    ring: "ring-green/30",
    icon: (
      <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
        <circle cx="12" cy="7" r="4" />
      </svg>
    ),
    title: "Activo",
  },
  inactive: {
    color: "bg-red",
    ring: "ring-red/30",
    icon: (
      <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
        <circle cx="12" cy="7" r="4" />
        <line x1="4" y1="4" x2="20" y2="20" strokeWidth="3" />
      </svg>
    ),
    title: "Inactivo",
  },
};

export function StatusBadge({ status, className = "" }: StatusBadgeProps) {
  const { t } = useTranslation();
  const { color, ring, icon, title } = statusConfig[status ? "active" : "inactive"];

  return (
    <div
      title={t(title)}
      className={`w-5 h-5 shrink-0 flex items-center justify-center rounded-full shadow-sm ring-2 ring-offset-2 ring-offset-[#2d2f32] ${color} ${ring} ${className}`}
    >
      {icon}
    </div>
  );
} 